/**
 * Hook: useFetchValidationScoringConfig
 *
 * ADD this file to: datatool_fe-QA/src/hooks/useFetchValidationScoringConfig.tsx
 */
import { useEffect, useState } from "react";
import { IValidationScoringConfig } from "../types/Scoring.type";
import { getValidationScoringConfigByResource } from "../services/scoringService";

interface IuseFetchValidationScoringConfig {
  setIsLoading: any;
  resourceId: any;
}

const useFetchValidationScoringConfig = ({
  setIsLoading,
  resourceId,
}: IuseFetchValidationScoringConfig) => {
  const [validationScoringConfig, setValidationScoringConfig] =
    useState<IValidationScoringConfig | null>(null);

  useEffect(() => {
    if (resourceId && resourceId > 0) {
      setIsLoading(true);
      const fetchConfig = async () => {
        try {
          const result = await getValidationScoringConfigByResource(resourceId);
          setValidationScoringConfig(result);
        } catch (err) {
          setValidationScoringConfig(null);
        } finally {
          setIsLoading(false);
        }
      };
      fetchConfig();
    }
  }, [resourceId]);

  return [validationScoringConfig];
};

export default useFetchValidationScoringConfig;
